import React from 'react';
import { BottomNav as SharedBottomNav } from '@nsi-advisory-services/components';
import useNavItems from './navItems';

export default function BottomNav() {
  return <SharedBottomNav items={useNavItems()} />;
}
